import { StatusBar } from 'expo-status-bar'
import { createNativeStackNavigator } from '@react-navigation/native-stack'

// screens
import TakePictureScreen from '../screens/home/TakePictureScreen'

const Stack = createNativeStackNavigator()

const CameraStack = ({ route }): JSX.Element => {
  const { params } = route

  return (
    <>
      <Stack.Navigator initialRouteName="TakePicture">
        <Stack.Screen
          options={{ headerShown: false }}
          name="TakePicture"
          component={TakePictureScreen}
          initialParams={{ ...params }}
        />
      </Stack.Navigator>
      <StatusBar style="light" />
    </>
  )
}

export default CameraStack
